import { render, staticRenderFns } from "./BankAccountView.vue?vue&type=template&id=28ea46db&scoped=true&"
import script from "./BankAccountView.vue?vue&type=script&lang=js&"
export * from "./BankAccountView.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountView.vue?vue&type=style&index=0&id=28ea46db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea46db",
  null
  
)

export default component.exports